/* global angular */

(function () {
    "use strict";

    var app = angular.module('app');

    app.directive('slickHero', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            compile: function compile(element, attributes, transclude) {
                var html = element[0].innerHTML;
                return {
                    pre: function (scope, element, attributes, controller) {
                        var watch = attributes.slickHero;

                        function doSlick(items) {
                            if (element.find('> div').length > 0 && !element.hasClass('slick-initialized')) {
                                element.slick({
                                    autoplay: true,
                                    autoplaySpeed: 4000,
                                    fade: false,
                                    arrows: false,
                                    dots: true,
                                    infinite: true,
                                    swipeToSlide: true
                                });
                            }
                        }
                        function onSlick(items) {
                            if (element.hasClass('slick-initialized')) {
                                element.slick('unslick');
                                element.html(html);
                                $compile(element.contents())(scope);
                            }
                            $timeout(function () {
                                doSlick(items);
                            });
                        }
                        scope.$watchCollection(watch, function (items) {
                            $timeout(function () {
                                onSlick(items);
                            });
                        });
                    }
                }
            },
        };
    }]);

    app.directive('slickTrainings', ['$compile', '$timeout', function ($compile, $timeout) {
        return {
            restrict: 'A',
            compile: function compile(element, attributes, transclude) {
                var html = element[0].innerHTML;
                return {
                    pre: function (scope, element, attributes, controller) {
                        var watch = attributes.slickTrainings;
                        function doSlick(items) {
                            if (element.find('> div').length > 0 && !element.hasClass('slick-initialized')) {
                                element.slick({
                                    autoplay: true,
                                    arrows: true,
                                    dots: false,
                                    fade: false,
                                    infinite: false,
                                    swipeToSlide: true,
                                    autoplaySpeed: 4000,
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                    responsive: [{
                                        breakpoint: 1200,
                                        settings: {
                                            slidesToShow: 2,
                                            slidesToScroll: 2
                                        }
                                    }, {
                                        breakpoint: 960,
                                        settings: {
                                            slidesToShow: 1,
                                            slidesToScroll: 1
                                        }
                                    }],
                                });
                                var nodes = [].slice.call(element[0].querySelectorAll('.training-card'));
                                if (items && items.length === nodes.length) {
                                    nodes.filter(function (node, i) {
                                        node = angular.element(node).contents();
                                        var $scope = scope.$new(false);
                                        $scope.item = items[i];
                                        $compile(node)($scope);
                                    });
                                }
                            }
                        }
                        function onSlick(items) {
                            if (element.hasClass('slick-initialized')) {
                                element.slick('unslick');
                                element.html(html);
                                $compile(element.contents())(scope);
                            }
                            $timeout(function () {
                                doSlick(items);
                            });
                        }
                        scope.$watchCollection(watch, function (items) {
                            if (items) {
                                $timeout(function () {
                                    onSlick(items);
                                });
                            }
                        });
                    }
                }
            },
        };
    }]);

    app.directive('slickFade', ['$timeout', function ($timeout) {
        return {
            restrict: 'A',
            compile: function compile(element, attributes, transclude) {
                var html = element[0].innerHTML;
                return {
                    pre: function (scope, element, attributes, controller) {
                        var watch = attributes.slickFade;

                        function doSlick(items) {
                            if (element.find('> div').length > 0 && !element.hasClass('slick-initialized')) {
                                element.slick({
                                    autoplay: true,
                                    autoplaySpeed: 4000,
                                    fade: true,
                                    arrows: false,
                                    dots: false,
                                    infinite: true,
                                    swipeToSlide: true
                                });
                            }
                        }
                        function onSlick(items) {
                            if (element.hasClass('slick-initialized')) {
                                element.slick('unslick');
                                element.html(html);
                                $compile(element.contents())(scope);
                            }
                            $timeout(function () {
                                doSlick(items);
                            });
                        }
                        scope.$watchCollection(watch, function (items) {
                            $timeout(function () {
                                onSlick(items);
                            });
                        });
                    }
                }
            },
        };
    }]);

    app.directive('slickHowto', ['$timeout', 'Utils', function ($timeout, Utils) {
        return {
            restrict: 'A',
            compile: function compile(element, attributes, transclude) {
                var html = element[0].innerHTML;
                return {
                    pre: function (scope, element, attributes, controller) {
                        var watch = attributes.slickHowto;

                        var busy = false;

                        function doSlick(items) {
                            if (element.find('> section').length > 0 && !element.hasClass('slick-initialized')) {
                                element.slick({
                                    autoplay: false,
                                    fade: false,
                                    arrows: false,
                                    dots: true,
                                    infinite: false,
                                    vertical: true,
                                    verticalSwiping: true,
                                    responsive: [{
                                        breakpoint: 719,
                                        settings: 'unslick'
                                    }],
                                    onAfterChange: function (e) {
                                        console.log('onAfterChange', e);
                                        busy = false;
                                    }
                                });
                                element.on('afterChange', function (e, slick, currentSlide, nextSlide) {
                                    // console.log('onAfterChange', e, slick, currentSlide, nextSlide);
                                    busy = false;
                                });
                            }
                        }
                        function onSlick(items) {
                            if (element.hasClass('slick-initialized')) {
                                element.slick('unslick');
                                element.html(html);
                                $compile(element.contents())(scope);
                            }
                            $timeout(function () {
                                doSlick(items, 100);
                            });
                        }
                        scope.$watchCollection(watch, function (items) {
                            $timeout(function () {
                                onSlick(items);
                            });
                        });

                        function _onWheelSlick(e) {
                            if (!busy) {
                                busy = true;
                                if (e.originalEvent.deltaY > 0) {
                                    element.slick('slickNext');
                                } else {
                                    element.slick('slickPrev');
                                }
                            }
                        }
                        var onWheelSlick = Utils.throttle(_onWheelSlick, 2000);
                        function onWheel(e) {
                            var flag = false;
                            if (window.innerWidth < 760) {
                                return;
                            }
                            if (element.hasClass('slick-initialized')) {
                                if (e.originalEvent.deltaY > 0) {
                                    flag = element.slick('slickCurrentSlide') < element[0].querySelectorAll('.slick-item').length - 1;
                                } else {
                                    // flag = element.slick('slickCurrentSlide') > 0;
                                }
                                _onWheelSlick(e);
                                if (flag) {
                                    e.stopImmediatePropagation;
                                    e.preventDefault();
                                }
                            }
                        }

                        element.on('wheel', onWheel);

                        scope.$on('destroy', function () {
                            element.off('wheel', onWheel);
                        });
                    }
                }
            },
        };
    }]);

}());